import React from "react";

/**
 * ProgressBar Props Interface
 * @interface ProgressBarProps
 */
interface ProgressBarProps {
  /** Progress percentage (0 to 100) */
  progress: string | null;
  /** Background color */
  bgColor: string;
  /** Progress bar color */
  progressColor: string;
}

/**
 * ProgressBar Component
 * A reusable progress bar component used to know the completion percentage in the bar graph
 */
const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  bgColor,
  progressColor,
}) => {
  return (
    <div
      className={`relative w-100 h-10px radius-20px overflow-hidden ${bgColor} max-w-960px`}
    >
      <div
        className={`h-100 radius-20px transition-all ${progressColor}`}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ProgressBar;